<div class="p-mt-5">
  <div class="search-container">
    <div class="search-query">
      <dx-text-box
        id="mobileNumber"
        [style]="{ width: '225px' }"
        placeholder="Search"
        [(value)]="searchQuery"
        (onKeyDown)="handleKeyDown($event)"
        >
      </dx-text-box>
      <div *ngIf="displayError">
        <small class="p-error">Please enter 3 or more characters</small>
      </div>
    </div>

    <div class="search-btn">
      <dx-button
        text="Search"
        stylingMode="contained"
        type="default"
        [disabled]="!searchQuery || searchQuery.length < 3"
        icon=""
        (click)="searchBtn()">
      </dx-button>
      <dx-button
        text="Reset"
        stylingMode="outlined"
        type="default"
        icon=""
        style="margin-left: 8px"
        (click)="onReset()">
      </dx-button>
    </div>
  </div>
</div>
